import { render, staticRenderFns } from "./PurchasingOrderMonitoring.vue?vue&type=template&id=eda94ad6&scoped=true&"
import script from "./PurchasingOrderMonitoring.vue?vue&type=script&lang=js&"
export * from "./PurchasingOrderMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingOrderMonitoring.vue?vue&type=style&index=0&id=eda94ad6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda94ad6",
  null
  
)

export default component.exports